/**
 * HLR Draft Order Checkout
 * Intercepts the checkout button on the cart page, creates a Shopify Draft Order
 * via Supabase Edge Function with the correct calculated prices, and redirects
 * the customer to the draft order invoice URL for payment.
 *
 * v2: Added variant_title to item payload for downstream hair length extraction
 */
(function() {
  'use strict';

  var EDGE_FUNCTION_URL = 'https://xikmescjdxalgfsyvqhx.supabase.co/functions/v1/create-draft-checkout';

  function init() {
    if (window.location.pathname !== '/cart') return;
    interceptCheckoutButtons();
    var observer = new MutationObserver(function() {
      interceptCheckoutButtons();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function interceptCheckoutButtons() {
    var btns = document.querySelectorAll(
      'button[name="checkout"], input[name="checkout"], [type="submit"][name="checkout"], a[href="/checkout"], .cart__checkout-button, .cart__checkout, #checkout, [data-checkout]'
    );
    btns.forEach(function(btn) {
      if (btn.dataset.hlrIntercepted) return;
      btn.dataset.hlrIntercepted = 'true';
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        handleCheckout(btn);
      }, true);
      var form = btn.closest('form');
      if (form && !form.dataset.hlrIntercepted) {
        form.dataset.hlrIntercepted = 'true';
        form.addEventListener('submit', function(e) {
          if (form.querySelector('[name="checkout"]') || form.action.indexOf('/checkout') !== -1) {
            e.preventDefault();
            e.stopPropagation();
            handleCheckout(btn);
          }
        }, true);
      }
    });
  }

  function handleCheckout(btn) {
    var originalText = btn.textContent || btn.value;
    if (btn.tagName === 'INPUT') {
      btn.value = 'Creating order...';
    } else {
      btn.textContent = 'Creating order...';
    }
    btn.disabled = true;
    btn.style.opacity = '0.6';
    btn.style.pointerEvents = 'none';

    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        if (!cart.items || cart.items.length === 0) {
          throw new Error('Cart is empty');
        }

        var items = cart.items.map(function(item) {
          return {
            variant_id: item.variant_id,
            product_id: item.product_id,
            title: item.product_title || item.title,
            variant_title: item.variant_title || '',
            quantity: item.quantity,
            price: item.price,
            properties: item.properties || {}
          };
        });

        return fetch(EDGE_FUNCTION_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: items,
            email: null,
            note: cart.note || '',
            currencyCode: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
            currencyRate: parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || '1') || 1
          })
        });
      })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (data.error) {
          throw new Error(data.error + (data.details ? ': ' + JSON.stringify(data.details) : ''));
        }
        if (!data.invoice_url) {
          throw new Error('No invoice URL returned');
        }
        window.location.href = data.invoice_url;
      })
      .catch(function(err) {
        console.error('[HLR Draft Checkout] Error:', err);
        alert('There was an error processing your checkout. Please try again.\n\n' + err.message);
        if (btn.tagName === 'INPUT') {
          btn.value = originalText;
        } else {
          btn.textContent = originalText;
        }
        btn.disabled = false;
        btn.style.opacity = '';
        btn.style.pointerEvents = '';
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();